import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  UrlTree,
} from '@angular/router';

import { Store } from '@ngxs/store';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { AuthState, SignIn } from '../state';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  /**
   *
   */
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  private gruard() {
    return this.store.select(AuthState.isAuthenticated).pipe(
      first(),
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.store.dispatch(new SignIn());
        }
      }),
      map((isAuthenticated) => isAuthenticated),
    );
  }

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.gruard();
  }

  canActivateChild():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.gruard();
  }

  canLoad():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.gruard();
  }
}
